import { Image, useTheme } from "@aws-amplify/ui-react";
import logoBanner from "./banner.jpg";

export function Header() {
  const { tokens } = useTheme();

  return <Image alt="logo" src={logoBanner} padding={tokens.space.zero} />;
}
